import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import useStyles from "../../themes/style";
import { IoIosImages, IoMdPerson } from "react-icons/io";
import { FaFileAlt } from "react-icons/fa";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useNotification } from "../../hooks/useNotification";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useUserDetails } from "../../context/UserDataContext";
import ChangePassword from "./ChangePassword";
import UpdateProfile from "./UpdateProfile";
import UpdateLogo from "./UpdateLogo";
import { IoKeySharp } from "react-icons/io5";
import UploadExistingCandidates from "./UploadExistingCandidates";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "14px 0px" }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const ProfilePage = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const userId = new URLSearchParams(location.search).get("userId");
  const {
    profileMenuName,
    profileImage,
    fetchViewUsersData,
  } = useUserDetails();
  const [profileData, setProfileData] = useState(null);
  const [profileImageData, setProfileImageData] = useState(null);

  const tabConfig = [
    {
      label: "Profile",
      icon: <IoMdPerson size={20} />,
      path: `/app/profile?tab=0`,
      hasTabPanel: true,
    },
    {
      label: "Change Password",
      icon: <IoKeySharp size={20} />,
      path: `/app/profile?tab=1`,
      hasTabPanel: true,
    },
    {
      label: "Upload Existing Candidates",
      icon: <FaFileAlt size={20} />,
      path: `/app/profile?tab=2`,
      hasTabPanel: true,
    },
    {
      label: "Logo",
      icon: <IoIosImages size={20} />,
      path: `/app/profile?tab=3`,
      hasTabPanel: true,
    },
  ];

  const [tabValue, setTabValue] = React.useState(0);
  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();
  const [confimationOpen, setConfimationOpen] = useState(false);

  const handleConfirmationModalOpen = () => {
    setConfimationOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    const selectedTab = tabConfig[newValue];
    setTabValue(newValue);
    if (selectedTab?.path) {
      history.push(selectedTab.path);
    }
  };

  useEffect(() => {
    setProfileData(profileMenuName);
    setProfileImageData(profileImage);
  }, [profileMenuName, profileImage]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = parseInt(params.get("tab"));

    if (!isNaN(tab)) {
      setTabValue(tab);
    } else {
      setTabValue(0); // Default to the first tab if no tab is specified
    }
  }, [location.search]);

  async function handleEmployeeSeparation() {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/triggerSeperation`,
        {
          userId: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleConfirmationModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.log("Error Fetch Profile Data", error);
    }
  }

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MuiTab: {
          root: {
            "&.Mui-selected": {
              background: "none",
            },
            "&": {
              minWidth: "18%",
            },
          },
        },
      },
    });

  return (
    <div>
      <Box display="flex" flexDirection="column" gridGap={5} my={0}>
        <List
          className={`${classes.root} m-0`}
          style={{
            backgroundImage:
              "linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)",
            borderRadius: "8px 8px 0 0",
          }}
        >
          <ListItem
            alignItems="flex-start"
            style={{ display: "flex", gap: "10px" }}
          >
            <ListItemAvatar style={{ marginTop: "14px" }}>
              <Avatar
                src={profileImageData?.image}
                alt="Profile"
                style={{ width: "80px", height: "80px" }}
              />
            </ListItemAvatar>
            <ListItemText
              primary={
                <React.Fragment>
                  <PageTitle
                    title={
                      profileData?.recruiter &&
                      `${profileData?.recruiter.firstName} ${profileData?.recruiter.lastName}`
                    }
                  />
                </React.Fragment>
              }
              secondary={
                <Box
                  component="span"
                  display="flex"
                  flexDirection="column"
                  gridGap={5}
                >
                  <Box component="span">{profileData?.email}</Box>
                  <Box component="span">
                    {profileData?.roleName === "CLIENTCOORDINATOR"
                      ? "Hiring Manager"
                      : profileData?.roleName === "SUBVENDOR"
                      ? "Freelancer"
                      : profileData?.roleName === "SUBCONTRACT"
                      ? "Vendor"
                      : profileData?.roleName}
                    {" - "}
                    {profileData?.recruiter?.companyName}
                  </Box>
                </Box>
              }
            />
          </ListItem>
        </List>

        {/* <Typography variant="subtitle1"></Typography>
        <Typography variant="subtitle1"></Typography> */}
      </Box>

      <AppBar
        position="static"
        style={{
          background: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
          border: "2px solid #EEEEEE",
          borderRadius: "0 0 8px 8px",
          boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px",
          zIndex: 1,
        }}
      >
        <MuiThemeProvider theme={getMuiTheme()}>
          <Tabs
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className={classes.userInfoTabList}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#000",
                height: "2px",
                borderRadius: "8px",
                zIndex: 0,
              },
            }}
          >
            {tabConfig.map((tab, index) => (
              <Tab key={index} label={tab.label} icon={tab.icon} />
            ))}
          </Tabs>
        </MuiThemeProvider>
      </AppBar>

      <TabPanel value={tabValue} index={0}>
        <UpdateProfile
          userDetails={profileData}
          onUpdate={fetchViewUsersData}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ChangePassword onUpdate={fetchViewUsersData} />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <UploadExistingCandidates
          userDetails={profileData}
          onUpdate={fetchViewUsersData}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <UpdateLogo
          logoDetails={profileImageData}
          onUpdate={fetchViewUsersData}
        />
      </TabPanel>

      <Dialog
        onClose={handleConfirmationModalClose}
        aria-labelledby="dialog-title"
        open={confimationOpen}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Confirmation
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                onClick={handleConfirmationModalClose}
                size="14px"
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <Typography variant="subtitle2">
            Do you really wish to separate this employee from the organization?
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleEmployeeSeparation}
            >
              Yes
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleConfirmationModalClose}
            >
              No
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default ProfilePage;
